import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=644a718d&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3794794342/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644a718d')) {
      api.createRecord('644a718d', component.options)
    } else {
      api.reload('644a718d', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=644a718d&", function () {
      api.rerender('644a718d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Dashboard.vue"
export default component.exports